import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { PointerType } from '../model/pointer-type.model';

export function getPointerTypeI18n(pointerType: PointerType): string {
  switch (pointerType) {
    case PointerType.Mouse:
      return marker('POINTER_TYPE.MOUSE');
    case PointerType.Pen:
      return marker('POINTER_TYPE.PEN');
    case PointerType.Touch:
      return marker('POINTER_TYPE.TOUCH');
    default:
      throw new Error(`Invalid pointer type "${pointerType}"`);
  }
}
